// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useTranslate } from '../LocaleProvider';
import { getLocaleMessages } from './locale';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Translate` component.
 * @since 0.0.42
 */
const Translate = _ref => {
  let {
    component,
    content,
    children,
    params,
    unsafe,
    fallback,
    namespace,
    translators,
    defaultMessages,
    ...props
  } = _ref;
  const Tag = component || 'span';
  const translate = useTranslate(namespace);
  const key = content || children || '';
  const translator = translators && translators[key];
  if (translator) {
    if (typeof translator === 'function') {
      return translator(params);
    }
    return translator;
  }
  const message = translate(key, params, fallback, defaultMessages);
  const tagProps = {
    ...props
  };
  if (unsafe) {
    tagProps.dangerouslySetInnerHTML = {
      __html: message
    };
  } else {
    tagProps.children = message;
  }
  return /*#__PURE__*/_jsx(Tag, {
    ...tagProps
  });
};
export default Translate;
export const InternalTranslate = props => {
  const defaultMessages = getLocaleMessages();
  return /*#__PURE__*/_jsx(Translate, {
    ...props,
    defaultMessages: defaultMessages
  });
};